import cn from 'classnames';
import { PropsWithChildren } from 'react';

import {
  InfoPanelType,
  InfoPanelTypes,
  InfoPanelVariants,
  InfoPanelVariant,
} from '@shared/components/InfoPanel/InfoPanel.types.ts';

import styles from './InfoPanel.module.scss';

interface InfoPanelProps {
  type: InfoPanelType;
  variant?: InfoPanelVariant;
  headerText?: string;
  className?: string;
}

function determineIcon(type: InfoPanelType) {
  switch (type) {
    case InfoPanelTypes.INFO:
      return 'pi-exclamation-circle';
    case InfoPanelTypes.WARNING:
      return 'pi-exclamation-triangle';
    default:
      return 'pi-exclamation-circle';
  }
}

export function InfoPanel({
  type,
  headerText,
  className,
  children,
  variant = InfoPanelVariants.DEFAULT,
}: PropsWithChildren<InfoPanelProps>) {
  const panelClass = type.toLowerCase();
  const iconClass = determineIcon(type);

  const isCompactVariant = variant === InfoPanelVariants.COMPACT;

  return (
    <div className={cn(styles.container, styles[panelClass], className, { [styles.compactVariant]: isCompactVariant })}>
      <i className={cn(`pi ${iconClass}`, styles.icon)} />

      <div className={styles.contentContainer}>
        {headerText && <h3 className={styles.header}>{headerText}</h3>}
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}
